import type { DbResult } from "@travelix/core";

/**
 * Unwrap a core `{ data, error }` result for TanStack Query: resolve with the
 * data or throw the error, so query/mutation functions stay one-liners.
 *
 *   mutationFn: () => unwrap(addTripIdea(trip.id, idea))
 */
export async function unwrap<T>(result: Promise<DbResult<T>>): Promise<T> {
  const { data, error } = await result;
  if (error) throw error;
  // Core never returns { data: null, error: null } — misses surface as errors.
  return data as T;
}

export const ok = <T>(data: T): DbResult<T> => ({ data, error: null });

export const DEMO_UNAVAILABLE_MESSAGE =
  "That's for real trips — create your own to try it with friends.";

/** What group-only actions return for the onboarding sample trip. */
export const demoUnavailable = <T>(): DbResult<T> => ({
  data: null,
  error: new Error(DEMO_UNAVAILABLE_MESSAGE),
});
